// eslint-disable-next-line no-shadow
export enum Modality {
	Monthly = 'Monthly',
	Annually = 'Yearly',
}
